var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2324_2145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.50958 4.5004L0.206384 1.19632C-0.0673561 0.922503 -0.0673561 0.479443 0.206384 0.20563C0.480123 -0.0681839 0.923063 -0.0681839 1.1968 0.20563L4.5 3.50972L7.8032 0.204552C8.07694 -0.0681839 8.52096 -0.0681839 8.7947 0.204552C9.06843 0.477287 9.06843 0.921425 8.7947 1.19524L5.4915 4.49933L8.7947 7.80449C9.06843 8.07831 9.06843 8.52137 8.7947 8.79518C8.65783 8.93209 8.47892 9 8.29895 9C8.11897 9 7.94007 8.93209 7.8032 8.79518L4.5 5.49109L1.1968 8.79518C1.05993 8.93209 0.881033 9 0.701055 9C0.521075 9 0.342175 8.93209 0.205305 8.79518C-0.0684347 8.52137 -0.0684347 8.07831 0.205305 7.80449L3.5085 4.5004H3.50958Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2324_2145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "white",
    transform: "matrix(-1 0 0 1 9 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveX);
export default __webpack_public_path__ + "static/media/remove-x.130d1e65.svg";
export { ForwardRef as ReactComponent };